import {debounce} from "../utilities/Helper";
import Api from "../service/Api";
import {mediaBreakpointDown} from "../utilities/MediaBreakpoints";

const DEBOUNCE_DELAY = 500;
const LOADING_CLASS_NAME = 'loading';

const searchCollapse = document.querySelector('gnd-collapse#searchResultsCollapse');
const searchResultsSlot = document.querySelector('.search-results__slot');


const config = {
    values: {
        clearButtonText: '',
        minCharacters: 0,
        emptyLabel: '',
        mothingFoundLabel: '',
        placeholder: ''
    },
    elements: {
        get formElement() {
            return document.querySelector('form#knowledgeRepositorySearchForm');
        },
        get searchInputElement() {
            return this.formElement.elements['input-search'];
        },
        get searchResultsLabelElement() {
            return document.querySelector('.search-results__placeholder');
        },
        get clearButton() {
            return document.querySelector('.clear-search');
        },
        get spinnerElement() {
            return document.querySelector('gnd-spinner#searchSpinner');
        }
    },
    actions: {
        updateElementValues: () => {
            config.elements.searchInputElement.placeholder = config.values.placeholder;
            config.elements.searchResultsLabelElement.textContent = config.values.emptyLabel;
            config.elements.clearButton.textContent = config.values.clearButtonText;
        },
        setNothingFoundLabel: (config, payload) => {
            config.elements.searchResultsLabelElement.textContent = payload;
        }
    }
}

function getSearchResults(value) {
    setLoading(true);
    config.actions.setNothingFoundLabel(config, config.values.emptyLabel);
    Api.searchByKnowledgeRepository(value)
        .then((results) => {
            clearResults();
            renderResults(results);
            config.actions.setNothingFoundLabel(config, results.length);
        })
        .catch(() => {
            config.actions.setNothingFoundLabel(config, config.values.mothingFoundLabel);
            clearResults();
        })
        .finally(() => {
            setLoading(false)
            if (mediaBreakpointDown('lg')) {
                config.elements.searchInputElement.blur();
            }
        });
    if (mediaBreakpointDown('lg')) {
        searchCollapse.show();
    }
}

function updateClearButtonState(length) {
    if (length > 0) {
        config.elements.clearButton.style.display = 'block';
    } else {
        config.elements.clearButton.style.display = 'none';
    }
}

function shouldMakeSearchApiCall(searchLength) {
    return isNaN(config.values.minCharacters) || config.values.minCharacters <= searchLength;
}

const handleSearchInput = debounce(({target}) => {
    if (!shouldMakeSearchApiCall(target.value.length) || mediaBreakpointDown('lg')) return;
    updateClearButtonState(target.value.length);
    getSearchResults(target.value);
}, DEBOUNCE_DELAY);

function setLoading(value) {
    value ? config.elements.spinnerElement.classList.add(LOADING_CLASS_NAME) : config.elements.spinnerElement.classList.remove(LOADING_CLASS_NAME);
}

function handleClearButtonMouseDown(event) {
    event.preventDefault();
    config.elements.searchInputElement.focus();
}

function handleClearButton(event) {
    config.elements.searchInputElement.value = "";
    event.stopPropagation();
    event.preventDefault();
    event.target.style.display = 'none';
    config.actions.setNothingFoundLabel(config, config.values.emptyLabel);
    clearResults();
}

function handleSearchFocus(e) {
    if (mediaBreakpointDown('lg')) return;
    searchCollapse.show();
    updateClearButtonState(e.target.value.length);
}

function handleSearchBlur(e) {
    if (mediaBreakpointDown('lg')) return;
    e.stopPropagation();
    searchCollapse.hide();
    updateClearButtonState(0);

}

function handleFormSubmit(e) {
    e.preventDefault();
    if (!mediaBreakpointDown('lg')) return;
    updateClearButtonState(config.elements.searchInputElement.value.length);
    getSearchResults(config.elements.searchInputElement.value);
}

function clearResults() {
    while (searchResultsSlot.firstChild) {
        searchResultsSlot.removeChild(searchResultsSlot.firstChild);
    }
}

function renderResults(results) {
    const resultsList = document.createElement('ul');
    resultsList.append(...results.map((result) => {
        const resultListItem = document.createElement('li');
        resultListItem.innerHTML =
            `<a href="${result.url}">
                <div class="term-title">${result.label}</div>
                <div class="result-title">${result.title}</div>
             </a>
             `
        return resultListItem;
    }));
    searchResultsSlot.append(resultsList);
}

function setFormSearchValues(response) {
    if (typeof response === 'undefined') return;
    config.values.emptyLabel = response.empty_label;
    config.values.mothingFoundLabel = response.nothing_found_label;
    config.values.placeholder = response.placeholder;
    config.values.minCharacters = parseInt(response.minimum_characters);
    config.values.clearButtonText = response.clear_button_text;
    config.actions.updateElementValues();
}


function setupSearch() {
    Api.getSearchConfig().then((response) => setFormSearchValues(response));
    config.elements.searchInputElement.addEventListener('input', handleSearchInput, false);
    config.elements.searchInputElement.addEventListener('focusin', handleSearchFocus, false);
    config.elements.searchInputElement.addEventListener('focusout', handleSearchBlur, false);
    config.elements.clearButton.addEventListener('click', handleClearButton, false);
    config.elements.clearButton.addEventListener('mousedown', handleClearButtonMouseDown, false);
    config.elements.formElement.addEventListener('submit', handleFormSubmit, false);
}


export default function useSearch() {
    if (config.elements.formElement === null) return;
    setupSearch();
}
